"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordInput = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = __importDefault(require("classnames"));
var index_1 = require("../index");
var namespaceHack_1 = require("../../namespaceHack");
var PasswordInput = /** @class */ (function (_super) {
    __extends(PasswordInput, _super);
    function PasswordInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            visible: false,
            showPwdFocused: false
        };
        _this.toggleVisible = function () { return _this.setState({ visible: !_this.state.visible }); };
        _this.handleFocus = function (event) {
            var onInputFocus = _this.props.onInputFocus;
            _this.setState({
                currentStyles: _this.state.focusStyles
            });
            if (typeof onInputFocus === 'function') {
                onInputFocus(event);
            }
        };
        _this.handleBlur = function (event) {
            var onInputBlur = _this.props.onInputBlur;
            _this.setState({
                currentStyles: _this.state.blurStyles
            });
            if (typeof onInputBlur === 'function') {
                onInputBlur(event);
            }
        };
        _this.handleCheckboxFocus = function (event) {
            _this.setState({
                currentCheckboxStyles: _this.state.checkboxFocusStyles,
                showPwdFocused: true
            });
            if (_this.props.onCheckboxFocus) {
                _this.props.onCheckboxFocus();
            }
        };
        _this.handleCheckboxBlur = function (event) {
            _this.setState({
                currentCheckboxStyles: _this.state.blurStyles,
                showPwdFocused: false
            });
            if (_this.props.onCheckboxBlur) {
                _this.props.onCheckboxBlur();
            }
        };
        return _this;
    }
    PasswordInput.prototype.render = function () {
        var _a = this.props, className = _a.className, name = _a.name, label = _a.label, helpComponent = _a.helpComponent, focusColor = _a.focusColor, hearPasswordLabel = _a.hearPasswordLabel, mutePasswordLabel = _a.mutePasswordLabel, onCheckboxFocus = _a.onCheckboxFocus, onCheckboxBlur = _a.onCheckboxBlur, onInputFocus = _a.onInputFocus, onInputBlur = _a.onInputBlur, props = __rest(_a, ["className", "name", "label", "helpComponent", "focusColor", "hearPasswordLabel", "mutePasswordLabel", "onCheckboxFocus", "onCheckboxBlur", "onInputFocus", "onInputBlur"]);
        var classes = (0, classnames_1.default)("".concat(namespaceHack_1.NACKLE_PAPER_PREFIX, "-text-input"), "".concat(namespaceHack_1.NACKLE_PAPER_PREFIX, "-pwd-input"), 'with-icon-right', className);
        var _b = this.state, visible = _b.visible, currentStyles = _b.currentStyles;
        hearPasswordLabel = hearPasswordLabel ? hearPasswordLabel : 'Hear password';
        mutePasswordLabel = mutePasswordLabel ? mutePasswordLabel : 'Mute password';
        return (react_1.default.createElement("div", { className: classes },
            helpComponent
                && react_1.default.createElement("span", { className: "".concat(namespaceHack_1.NACKLE_PAPER_PREFIX, "-input-helper") }, helpComponent),
            label
                && react_1.default.createElement("label", { htmlFor: name }, label),
            react_1.default.createElement("div", { className: "".concat(namespaceHack_1.NACKLE_PAPER_PREFIX, "-input-wrap") },
                react_1.default.createElement(index_1.Input.Password, __assign({ type: visible ? 'text' : 'password', name: name, onFocus: focusColor ? this.handleFocus : null, onBlur: focusColor ? this.handleBlur : null, style: currentStyles }, props)))));
    };
    return PasswordInput;
}(react_1.Component));
exports.PasswordInput = PasswordInput;
PasswordInput.propTypes = {
    className: prop_types_1.default.string,
    name: prop_types_1.default.string,
    label: prop_types_1.default.node,
    helpComponent: prop_types_1.default.node,
    hearPasswordLabel: prop_types_1.default.string,
    mutePasswordLabel: prop_types_1.default.string,
    onCheckboxFocus: prop_types_1.default.func,
    onCheckboxBlur: prop_types_1.default.func
};
//# sourceMappingURL=password-input.js.map